module.exports = __webpack_public_path__ + "static/media/25682_1380855368144_312312_n.0b334dc1.jpg";